import React from "react";
import CellEllipsis from "./cellEllipsis";
import CellTimeSlot from "./cellTimeSlot";
import { CellDateProps } from "../table.types";
import DateTimeHelper from "shared/utils/dateTimeHelper";

/**
 * Use this for showing formatted date in table cell.
 *
 * @important While using this don't forget to use `dateFilterFunction`
 */
export default function CellDate({ shouldBreakLineAfterDate, ...props }: CellDateProps) {
  const CellComponentToRender = React.useMemo(
    () => (shouldBreakLineAfterDate ? CellTimeSlot : CellEllipsis),
    [shouldBreakLineAfterDate]
  );

  return (
    <CellComponentToRender
      {...props}
      value={
        props.value &&
        DateTimeHelper.formatDate({
          startDate: props.value,
          option: { showWeekDay: true, showTime: true }
        })
      }
    />
  );
}
